// if (!Object.values) Object.values = o=>Object.keys(o).map(k=>o[k]);
// if (!String.prototype.includes) {
//   String.prototype.includes = function(search, start) {
//     if (typeof start !== 'number') {
//       start = 0;
//     }
//
//     if (start + search.length > this.length) {
//       return false;
//     } else {
//       return this.indexOf(search, start) !== -1;
//     }
//   };
// }
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
